import { createFileRoute } from '@tanstack/react-router'
import { useReport } from '@/hooks/use-report'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { ReportComponent } from './-components/report/report'

export const Route = createFileRoute('/_app/jobs/_list/$jobId/report')({
  component: RouteComponent,
  pendingComponent: NestedReportPending,
  // Painted on the click frame (router defaultPendingMs 0): at the library's 1000ms a navigation whose loaders
  // resolve inside a second rendered NOTHING new, and on a phone the NAV STACK could not push — the level it would
  // push is the route being rendered (see useRenderedPathname), still the old one. Measured on a device as "tapping
  // an integrant only marks it selected; the report never opens". A cached navigation costs at most one frame of it.
})

function RouteComponent() {
  const context = Route.useRouteContext()
  const { report, isFetching } = useReport(context.reportQueryOptions)
  return <ReportComponent report={report} isFetching={isFetching} />
}
